class UserNotificationListCtrl {
  constructor($timeout, $scope, $rootScope, EventService) {
    'ngInject';
    Object.assign(this, { $timeout, $scope, $rootScope });
    this.es = EventService;
  }

  async $onInit() {
    this.watchUserMessages();
  }

  watchUserMessages() {
    this.loadMessages();
    this.$scope.$watch('$root.userMessages', () => {
      this.loadMessages();
    });
  }

  loadMessages() {
    this.userMessages = (this.$rootScope.userMessages?.list || []);
    this.loadAlerts();
    this.loadBanners();
    this.timeoutMessages();
  }

  loadAlerts() {
    this.userAlerts = this.userMessages.filter(m => m.type != 'Banner');
    this.$timeout(_ => this.userAlerts.forEach(m => $(`#notification-${m.id}`).fadeIn()));
  }

  loadBanners() {
    this.userBanners = this.userMessages.filter(m => m.type == 'Banner');
    if (this.userBanners.length === 0) return;
    
    // NOTE: there's only one banner placeholder for now (library header), but we could add more
    const bannerBody = (m) => `<span id="notification-${m.id}">${m.message}</span>`;
    $('.fe-banner').html(this.userBanners.reduce((acc, m) => acc + bannerBody(m), ''));
  }

  timeoutMessages() {
    this.$timeout(_ => {
      this.userMessages.forEach(m => {
        const id = m.id;
        const millisecs = m.duration * 1000;
        if (millisecs <= 0) return;
        this.$timeout(_ => this.hideMessage(id), millisecs);
      });
    });
  }

  showMessage(id) {
    this.es.dispatchEvent(this.es.actions.USER_MESSAGE_SELECTED, { messageId: id } );
  }

  hideMessage(id, e) {
    $(`#notification-${id}`).fadeOut();
    e && e.stopPropagation();
  }
}

export default {
  bindings: {},
  templateUrl: 'form-builder/user-notification-list/user-notification-list.component.html',
  controller: UserNotificationListCtrl
};
